<template>
  <div class="ioc-transfer">
    <div class="content-top">
      <div class="content-top-left">
        <div class="title">
          {{ titles[0] }}
        </div>
        <div class="content-main">
          <div class="step-input" v-if="type === 'step' && addStepBool">
            <input
              v-model="stepValue"
              type="text"
              :disabled="disabled"
              class="input"
              :placeholder="$t('reserve.placeholder.preplannameStep')"
            />
            <span class="el-icon-check" @click="addReserveStep"></span>
            <span class="el-icon-close" @click="closeAddStep"></span>
          </div>
          <div>
            <el-input
              v-model="roleName"
              clearable
              :placeholder="'请输入' + subTitleText"
              :disabled="disabled"
              class="input-with-select"
            >
            </el-input>
          </div>
          <el-row class="right-title" v-if="type === 'date'">
            <el-col :span="18" class="select-role">
              {{ subTitleText }}
              <span>{{ subTitleText == "账户" ? " / 姓名" : "" }}</span>
            </el-col>
          </el-row>
          <el-scrollbar class="scroll-bar">
            <div class="group-list-left" v-if="type === 'tree'">
              <el-tree
                class="tree-list"
                ref="left"
                v-model="checkAlarm"
                :data="leftTree"
                :props="props"
                :disabled="disabled"
                default-expand-all
                node-key="key"
                show-checkbox
                @check="leftTreeCheck"
              ></el-tree>
            </div>
            <div class="transfer-list-left transfer-list" v-else-if="type === 'date'">
              <el-checkbox-group v-model="leftChecked" :disabled="disabled">
                <el-row
                  v-for="(item, index) in sourceList"
                  :key="index"
                  class="transfer"
                  :title="
                    subTitleText == '账户'
                      ? item[props.label] + '【' + item.nickName + '】'
                      : item[props.label]
                  "
                >
                  <el-col :span="24">
                    <el-checkbox :key="item[props.key]" :label="item[props.label]">
                      <span>
                        {{ item[props.label] }}
                      </span>
                      <span v-if="subTitleText == '账户'"> 【{{ item.nickName }}】 </span>
                    </el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </div>
            <div class="transfer-list-left transfer-list" v-else-if="type === 'step'">
              <el-checkbox-group v-model="leftChecked" :disabled="disabled">
                <el-row
                  v-for="(item, index) in sourceList"
                  :key="index"
                  class="transfer"
                  :title="item[props.label]"
                >
                  <el-col :span="24">
                    <el-checkbox
                      style="
                        position: relative;
                        width: 100%;
                        height: 30px;
                        line-height: 30px;
                      "
                      :key="item[props.key]"
                      :label="item[props.label]"
                    >
                      {{ item[props.label] }}
                      <div style="position: absolute; top: 24%; right: 0">
                        <span
                          class="el-icon-delete"
                          v-if="item.planStepType === 1"
                          style="margin-right: 10px; width: 17px"
                          @click="deleteStep(item)"
                        ></span>
                      </div>
                    </el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </div>
            <div class="transfer-list-left transfer-list" v-else>
              <el-checkbox-group v-model="leftChecked" :disabled="disabled">
                <el-row
                  v-for="(item, index) in sourceList"
                  :key="index"
                  class="transfer"
                  :title="item[props.label]"
                >
                  <el-col :span="24">
                    <el-checkbox :key="item[props.key]" :label="item[props.label]">
                      <!-- <span class="text-ellipse">{{ item[props.label] }}</span> -->
                    </el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div class="content-top-middle">
        <div style="text-align: center; margin-bottom: 30px">
          <img
            src="@src/common/assets/images/arrows_left.png"
            @click="transferPerson('left')"
            style="cursor: pointer"
            alt=""
          />
        </div>
        <div style="text-align: center">
          <img
            src="@src/common/assets/images/arrows_right.png"
            @click="transferPerson('right')"
            alt=""
            style="cursor: pointer"
          />
        </div>
      </div>
      <div class="content-top-right" :class="type">
        <div class="title">
          <!-- <span
            class="flagStyle"
            style="display: inline-block; margin: 0 8px 0 8px"
          ></span> -->
          {{ titles[1] }}
        </div>
        <!-- <div style="margin: 8px;">
          <el-input v-model="selectRoleName"
                    @change="filterText"
                    @keyup.enter.native="filterText"
                    clearable
                    @clear="clearSearch"
                    :disabled="disabled"
                    class="input-with-select">
            <el-button slot="append"
                       icon="el-icon-search"
                       @click="filterText"></el-button>
          </el-input>
        </div> -->
        <div class="content-main">
          <div>
            <el-input
              v-model="selectRoleName"
              clearable
              :placeholder="'请输入' + subTitleText"
              :disabled="disabled"
              class="input-with-select"
            >
            </el-input>
          </div>
          <el-row class="right-title">
            <el-col :span="8" class="select-role">
              {{ subTitleText }}
              <span>{{ subTitleText == "账户" ? " / 姓名 " : "" }}</span>
            </el-col>
            <el-col :span="16" class="select-role">有效期</el-col>
          </el-row>

          <el-scrollbar class="scroll-bar">
            <div class="group-list" v-if="type === 'tree'">
              <el-tree
                class="tree-list"
                ref="right"
                :data="rightTree"
                default-expand-all
                node-key="key"
                :props="props"
                show-checkbox
                @check="rightTreeCheck"
                :renderContent="renderContent"
              ></el-tree>
            </div>
            <div class="transfer-list-right transfer-list" v-else-if="type === 'date'">
              <el-checkbox-group v-model="rightChecked" :disabled="disabled">
                <el-row
                  v-for="(item, index) in targetList"
                  :key="index"
                  class="transfer"
                  style="padding: 6px 0"
                  :title="
                    subTitleText == '账户'
                      ? item[props.label] + '【' + item.nickName + '】'
                      : item[props.label]
                  "
                >
                  <el-col :span="10">
                    <el-checkbox
                      style="justify-content: start"
                      :key="item[props.key]"
                      :label="item[props.label]"
                    >
                      <!-- <i class="iconfont icon-anbao"></i> -->
                      <!-- {{ item.label }} -->

                      <span>
                        {{ item[props.label] }}
                      </span>
                      <span v-if="subTitleText == '账户'"> 【{{ item.nickName }}】 </span>
                    </el-checkbox>
                  </el-col>
                  <el-col class="date-range-column" :span="14">
                    <el-date-picker
                      v-model="item.date"
                      size="mini"
                      type="daterange"
                      @change="dateChange"
                      :default-time="['00:00:00', '23:59:59']"
                      :disabled="disabled"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </div>
            <div class="transfer-list-right transfer-list" v-else-if="type === 'step'">
              <el-checkbox-group v-model="rightChecked" :disabled="disabled">
                <el-row
                  v-for="(item, index) in targetList"
                  :key="index"
                  class="transfer"
                  :title="item[props.label]"
                >
                  <el-col>
                    <el-checkbox
                      style="
                        position: relative;
                        width: 100%;
                        height: 30px;
                        line-height: 30px;
                      "
                      :key="item[props.key]"
                      :label="item[props.label]"
                    >
                      {{ item[props.label] }}
                      <div
                        v-if="!isOperation"
                        style="position: absolute; top: 24%; right: 0"
                      >
                        <img
                          v-if="index !== 0"
                          style="margin-right: 10px; width: 17px"
                          @click="moveUpClick(index)"
                          src="@/modules/reserve/image/move_up.svg"
                          :alt="$t('linkage.label.up')"
                        />
                        <img
                          type="text"
                          v-if="index !== targetList.length - 1"
                          @click="moveDownClick(index)"
                          src="@/modules/reserve/image/move_down.svg"
                          :alt="$t('linkage.label.down')"
                          style="width: 17px"
                        />
                      </div>
                      <div v-else>
                        <!--{{scope.row.order}}-->
                      </div>
                    </el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </div>
            <div class="transfer-list-right transfer-list" v-else>
              <el-checkbox-group v-model="rightChecked" :disabled="disabled">
                <el-row
                  v-for="(item, index) in targetList"
                  :key="index"
                  class="transfer"
                  :title="item[props.label]"
                >
                  <el-col>
                    <el-checkbox :key="item[props.key]" :label="item[props.label]">
                      <!-- <i class="iconfont icon-anbao"></i> -->
                      <!-- {{ item.label }} -->
                    </el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IocTransfer",
  /**
   * data: 数据源列表（左侧列表）格式与element保持一致
   * value：已选列表（右侧），格式与element一致
   * filterable：是否需要过滤
   * titles：标题，与element一致
   */
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    titles: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    props: {
      type: Object,
      default() {
        return {
          label: "label",
          key: "key",
          disabled: "disabled",
          children: "children",
        };
      },
    },
    type: {
      type: String,
      default: "",
    },
    subTitleText: {
      type: String,
      default: "角色",
    },
  },
  data() {
    return {
      stepValue: "",
      addStepBool: false,
      isOperation: true,
      checkAlarm: [],
      checked: [],
      leftChecked: [],
      rightChecked: [],
      selectedList: [],
      treeData: [],
      leftTreeSelect: [],
      rightTreeSelect: [],
      roleName: "",
      selectRoleName: "",
    };
  },
  computed: {
    sourceList() {
      return this.data.filter((item) => {
        return (
          item[this.props.label] &&
          item[this.props.label].indexOf(this.roleName.trim()) > -1 &&
          this.checked.indexOf(item[this.props.label]) === -1
        );
      });
    },
    targetList() {
      let list = this.data.filter((item) => {
        return this.checked.indexOf(item[this.props.label]) > -1;
      });
      list.sort((prev, next) => {
        return (
          this.checked.indexOf(prev[this.props.label]) -
          this.checked.indexOf(next[this.props.label])
        );
      });
      return list.filter((item) => {
        return (
          item[this.props.label] &&
          item[this.props.label].indexOf(this.selectRoleName.trim()) > -1 &&
          this.checked.indexOf(item[this.props.label]) !== -1
        );
      });
    },
    leftTree() {
      let list = [...this.data];
      return list.filter((item) => {
        if (item[this.props.children] && item[this.props.children].length) {
          item[this.props.children] = item[this.props.children].filter((child) => {
            return this.treeData.indexOf(child[this.props.key]) === -1;
          });
        }
        return item[this.props.children].length > 0;
        // return this.treeData.indexOf(item.key) === -1
      });
    },
    rightTree() {
      let list = [...this.data];
      return list.filter((item) => {
        if (item[this.props.children] && item[this.props.children].length) {
          item[this.props.children] = item[this.props.children].filter((child) => {
            return this.treeData.indexOf(child[this.props.key]) > -1;
          });
        }
        console.log("rightTree:", list);
        return item[this.props.children].length > 0;
        // return this.treeData.indexOf(item.key) > -1
      });
    },
  },
  watch: {
    targetList() {
      if (this.targetList.length > 1) {
        this.isOperation = false;
      } else {
        this.isOperation = true;
      }
    },
    value(data) {
      if (this.type === "tree") {
        let listTree = [];
        data.forEach((item) => {
          listTree.push(item[this.props.key]);
          if (item[this.props.children]) {
            listTree = listTree.concat(this.checkChildren(item[this.props.children]));
          }
        });
        this.treeData = [].concat(listTree);
        console.log("watch=>value:", this.treeData);
      } else {
        const list = data.map((r) => r[this.props.label]);
        this.checked = [].concat(list);
        console.log("watch=>value:", this.checked, data);
        this.data.forEach((item, index) => {
          delete item.date;
          let valueIndex = this.checked.indexOf(item[this.props.label]);
          if (
            valueIndex !== -1 &&
            data[valueIndex].date &&
            data[valueIndex].date.length
          ) {
            // item.date = [...data[valueIndex].date];
            let startDate =
              data[valueIndex].date[0] &&
              new Date(data[valueIndex].date[0].split("-").join("/"));
            let endDate =
              data[valueIndex].date[1] &&
              new Date(data[valueIndex].date[1].split("-").join("/"));
            this.$set(this.data[index], "date", [startDate, endDate]);
          }
        });
      }
      this.$emit("changeData", data);
    },
  },
  created() {},
  mounted() {},
  methods: {
    dateChange() {
      this.$emit("changeData", this.targetList);
    },
    // 向上移动
    moveUpClick(index) {
      if (this.disabled) {
        return;
      }
      if (index > 0 && !this.isOperation) {
        let upDate = this.checked[index - 1];
        this.checked.splice(index - 1, 1);
        this.checked.splice(index, 0, upDate);
      }
      this.rightChecked = [];
      console.log("向上移动", this.checked, this.targetList);
      this.$emit("changeData", this.targetList);
    },
    // 向下移动
    moveDownClick(index) {
      if (this.disabled) {
        return;
      }
      if (!this.isOperation) {
        let downDate = this.checked[index + 1];
        this.checked.splice(index + 1, 1);
        this.checked.splice(index, 0, downDate);
      }
      this.rightChecked = [];
      console.log(this.checked);
      console.log("向下移动", this.targetList);
      this.$emit("changeData", this.targetList);
    },
    onRightChange(row) {
      console.log("row:", row);
      console.log("value:", this.value);
    },
    leftTreeCheck(value) {
      console.log(value, "-----------");
      let list = this.$refs.left.getCurrentNode();
      console.log(value, "-----------");
      if (this.leftTreeSelect.indexOf(value[this.props.key]) === -1) {
        this.leftTreeSelect.push(value[this.props.key]);
        if (value[this.props.children]) {
          let key = this.checkChildren(value[this.props.children]);
          this.leftTreeSelect = this.leftTreeSelect.concat(key);
        }
      } else {
        this.leftTreeSelect.splice(this.leftTreeSelect.indexOf(value[this.props.key]), 1);
        if (value[this.props.children]) {
          this.removeChildren(value[this.props.children], this.leftTreeSelect);
        }
      }
    },
    rightTreeCheck(value) {
      if (this.rightTreeSelect.indexOf(value[this.props.key]) === -1) {
        this.rightTreeSelect.push(value[this.props.key]);
        if (value[this.props.children]) {
          let key = this.checkChildren(value[this.props.children]);
          this.rightTreeSelect = this.rightTreeSelect.concat(key);
        }
      } else {
        this.rightTreeSelect.splice(
          this.rightTreeSelect.indexOf(value[this.props.key]),
          1
        );
        if (value[this.props.children]) {
          this.removeChildren(value[this.props.children], this.rightTreeSelect);
        }
      }
    },
    removeChildren(list, target) {
      list.forEach((element) => {
        target.splice(target.indexOf(element[this.props.key]), 1);
      });
      if (list[this.props.children]) {
        this.removeChildren(list[this.props.children], target);
      }
    },
    checkChildren(list) {
      let keys = [];
      keys = list.map((item) => item[this.props.key]);
      if (list[this.props.children] && list[this.props.children].length) {
        let keys2 = this.checkChildren(list[this.props.children]);
        keys = keys.concat(keys2);
      }
      return keys;
    },
    // 自定义渲染节点
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node personwidth" title={node.label}>
          <span>
            <i
              class={
                node.level === 1
                  ? "iconfont-lunan icon-lunan-zu1870"
                  : "iconfont-lunan icon-lunan-lujing365"
              }
              style="margin-right: 5px"
            ></i>
            {node.label}
          </span>
        </span>
      );
    },
    // 数组扁平化
    flattenArr(arr) {
      const self = this;
      return arr.reduce((flat, toFlatten) => {
        return flat.concat(
          Array.isArray(toFlatten) ? self.flattenArr(toFlatten) : toFlatten
        );
      }, []);
    },
    // 移动人员
    transferPerson(type) {
      if (this.type === "date") {
        // 从左到右
        if (type === "right") {
          this.checked = this.checked.concat(this.leftChecked);
        } else if (type === "left") {
          // 移除右边已选人员
          this.checked = this.checked.filter(
            (item) => this.rightChecked.indexOf(item) === -1
          );
          // 清空时间有效期
          this.data.forEach((item) => {
            if (this.rightChecked.indexOf(item[this.props.label]) != -1) {
              delete item.date;
            }
          });
        }
        this.rightChecked = [];
        this.leftChecked = [];
      } else if (this.type === "tree") {
        if (type === "left") {
          console.log(this.checkAlarm, "this.checkAlarm");
          console.log(this.rightTreeSelect, "this.rightTreeSelect");
          // 移除右边已选人员
          this.treeData = this.treeData.filter(
            (item) => this.rightTreeSelect.indexOf(item) === -1
          );
        } else if (type === "right") {
          // this.selectedList = [].concat(this.selectTransferList);
          this.treeData = this.treeData.concat(this.leftTreeSelect);
          console.log(this.leftTreeSelect, "leftTreeSelect");
        }
        // this.value = this.checked;
        this.leftTreeSelect = [];
        this.rightTreeSelect = [];
      } else if (this.type === "step") {
        // 从左到右
        if (type === "left") {
          this.checked = this.checked.filter(
            (item) => this.rightChecked.indexOf(item) === -1
          );
          // console.log(this.rightChecked, "this.rightChecked");
          // console.log(this.checked, "this.checked");
        } else if (type === "right") {
          this.checked = this.checked.concat(this.leftChecked);
        }
        this.rightChecked = [];
        this.leftChecked = [];
      } else {
        // 从左到右
        if (type === "right") {
          // this.selectedList = [].concat(this.selectTransferList);
          this.checked = this.checked.concat(this.leftChecked);
        } else if (type === "left") {
          // 移除右边已选人员
          this.checked = this.checked.filter(
            (item) => this.rightChecked.indexOf(item) === -1
          );
        }
        // this.value = this.checked;
        this.rightChecked = [];
        this.leftChecked = [];
      }
      // 发送所有右侧数据给父组件
      const changeData = this.type === "tree" ? this.rightTree : this.targetList;
      this.$emit("changeData", changeData);
    },
    // 根据key对数组对象去重
    reduceArr(arr, key) {
      let obj = {};
      let newArr = arr.reduce((cur, next) => {
        obj[next[key]] ? "" : (obj[next[key]] = true && cur.push(next));
        return cur;
      }, []);
      return newArr;
    },
    filterRoleList(val) {
      // console.log(val);
    },
    addStep() {
      this.stepValue = "";
      this.addStepBool = true;
    },
    closeAddStep() {
      this.stepValue = "";
      this.addStepBool = false;
    },
    addReserveStep() {
      this.$emit("addStep", this.stepValue);
    },
    deleteStep(value) {
      this.$emit("deleteStep", value.planStepId);
    },
  },
};
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";
.ioc-transfer {
  margin-top: 24px;
  height: 100%;
  .content {
    &-top {
      display: flex;
      align-content: space-around;
      &-left,
      &-right {
        overflow: hidden;
        // width: 240px;
        // height: 300px;
        @include set_theme_color(background-color, main-content-bg-color);
        h2 {
          // @include set_theme_color(background-color, input-disabled-bg-color);
          margin-bottom: 0;
        }
        .account {
          line-height: 24px;
          padding: 0 10px;
          text-align: left;
        }
        .group-list {
          // height: 300px;
          // overflow-y: scroll;
          overflow: hidden;
        }
        .transfer-list {
          text-align: left;
          padding: 5px 10px 10px;
          overflow: hidden;
          .transfer {
            padding: 10px 0;
            border-bottom: 1px solid #C0C4CC;
            display: flex;
            flex-direction: row;
            align-items: center;
            .el-checkbox__label {
              display: block;
              // vertical-align: middle;
              max-width: 260px;
              width: 100%;
              // display: flex;
              // justify-content: space-around;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              .name {
                width: 120px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
      &-middle {
        width: 70px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-content: center;
        .to-left {
          // margin: 100px 0px 10px 0px;
          background: transparent;
          @include set_theme_color(color, active-border-color);
        }
        .to-right {
          // margin-left: 2px
          background: transparent;
          @include set_theme_color(color, active-border-color);
          // background: transparent;
        }
      }
      .date {
        flex: 1;
        width: 360px;
      }
    }
  }
  .scroll-bar {
    height: calc(100% - 70px);
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .dialog {
    .el-dialog__body {
      padding: 30px 0 0 0;
      background: rgb(53, 84, 134);
    }
  }
  .footer {
    text-align: right;
    padding: 20px 20px 20px 0;
    background: rgb(35, 57, 94);
  }
  .title {
    height: 32px;
    // color: #fff;
    font-size: 14px;
    line-height: 32px;
    text-align: center;
    font-weight: normal;
  }
  .right-title {
    margin-top: 10px;
    // height: 48px;
    line-height: 34px;
    // width: 300px;
    height: 34px;
    // background: #242b3d;
    @include set_theme_color(background-color,main-page-color);
    border-radius: 0px 0px 0px 0px;
  }
  .tree-list .personwidth {
    max-width: 220px;
    // overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .expand {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 2px;
    border: 1px solid #b3cbf1;
  }

  .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--datetimerange.el-input,
  .el-date-editor--datetimerange.el-input__inner {
    width: auto;
  }
  .content-top {
    height: 100%;
    position: relative;
  }
  .content-top-left {
    width: 40%;
    position: relative;
    @include set_theme_color(background-color, page-default-bg);
  }
  .content-top-left .el-icon-plus {
    position: absolute;
    top: 8px;
    right: 14px;
    color: #fff;
  }
  .content-top-middle {
    // height: 100%;
    width: 55px;
    display: flex;
    // flex-direction: column;
    justify-content: center;
    align-content: center;
  }
  .content-top-right {
    @include set_theme_color(background-color, page-default-bg);
  }
  .content-main {
    height: calc(100% - 30px);
    padding: 10px 6px;
    // @include set_theme_color(background-color, page-default-bg);
  }
  .step-input {
    margin: 8px 0 5px 15px;
  }
  .step-input .input {
    border: 1px solid rgb(88, 157, 246);
    height: 27px;
  }
  .step-input .input {
    width: 160px;
    color: #fff;
  }
  .step-input span {
    font-size: 16px;
    color: rgb(88, 157, 246);
  }
  .step-input .el-icon-check {
    font-size: 16px;
    margin: 0 6px;
  }
  .select-role {
    text-align: center;
    color: #fff;
  }

  .date-range-column {
    display: flex;
    flex-direction: row;
  }

  .el-checkbox {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .el-checkbox__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-date-editor .el-range-separator {
    width: 25px;
  }
}
</style>
